// extracted by mini-css-extract-plugin
export default {"container":"styles_container__cpJKt","greet":"styles_greet__620S4","text":"styles_text__FlzQT","img":"styles_img__O+7rB"};